import { render, staticRenderFns } from "./PieChartSources.vue?vue&type=template&id=0907c298&scoped=true&"
import script from "./PieChartSources.vue?vue&type=script&lang=js&"
export * from "./PieChartSources.vue?vue&type=script&lang=js&"
import style0 from "./PieChartSources.vue?vue&type=style&index=0&id=0907c298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0907c298",
  null
  
)

export default component.exports